// AboutPage.jsx
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { sanitize } from 'isomorphic-dompurify';

import { NULL_FUNCTION } from '../resource/defaults.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

import { color } from '../style/variables.js';
import BackIcon from '../../img/ic_topbar_back.svg';

const SANITIZE_CONFIG = { ADD_TAGS: ['style'], FORCE_BODY: true };
const HORIZONTAL_PADDING = 16;

export class AboutPage extends PureComponent {
  render() {
    const { close, t } = this.props;
    const string = t('about_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    });
    const dangerousHtml = { __html: sanitize(string, SANITIZE_CONFIG) };
    return (
      <StyledAboutPage>
        <Header>
          <CloseButton
            role="button"
            onClick={() => {
              close();
            }}
          >
            <CloseIcon src={BackIcon} title="close" />
          </CloseButton>
          <HeaderTitle>
            {t('about_swag', {
              ns: TranslationNamespace.SETTINGS,
            })}
          </HeaderTitle>
        </Header>
        <Body>
          <Description dangerouslySetInnerHTML={dangerousHtml} />
        </Body>
      </StyledAboutPage>
    );
  }
}

AboutPage.propTypes = {
  close: PropTypes.func,
  t: PropTypes.func.isRequired,
};

AboutPage.defaultProps = {
  close: NULL_FUNCTION,
};

const StyledAboutPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: ${color.neutral[0]};
  padding-top: var(--space-to-pinned-notification);
`;

const Header = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 1px solid ${color.neutral['30_alpha_40']};
  height: 58px;
  background-color: ${color.neutral[10]};
`;

const CloseButton = styled.div`
  box-sizing: content-box;
  position: absolute;
  top: 0;
  left: 0;
  padding: 14px ${HORIZONTAL_PADDING}px;
  cursor: pointer;
  height: 30px;
  :hover {
    opacity: 0.7;
  }
`;

const CloseIcon = styled.img`
  height: 100%;
  width: auto;
  vertical-align: top;
`;

const HeaderTitle = styled.div`
  flex: none;
  margin: 0px;
  font-size: 16px;
  color: ${color.neutral[100]};
`;

const Body = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  padding: 16px;
`;

const Description = styled.div`
  font-size: 14px;
  text-align: justify;
  line-height: 1.43;
  color: ${color.neutral[100]};
  overflow-wrap: break-word;

  img {
    max-width: 100%;
    height: auto;
  }

  table {
    max-width: 100%;
  }
`;

export default withTranslation()(AboutPage);
